module.exports = __webpack_public_path__ + "static/media/truck.0f8ff54b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/black/truck.svg
// module id = 461
// module chunks = 0